import { AvatarDesignTokens } from '@primeuix/themes/aura/avatar';

export const avatarTokens: AvatarDesignTokens = {
  root: {
    width: '2rem',
    height: '2rem',
    fontSize: '0.75rem',
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{color.main.secondary}',
  },
  icon: {
    size: '0.75rem',
  },
  group: {
    borderColor: '{content.background}',
    offset: '-0.5rem',
  },
  lg: {
    width: '3rem',
    height: '3rem',
    fontSize: '1.125rem',
    icon: {
      size: '1.125rem',
    },
    group: {
      offset: '-0.75rem',
    },
  },
  xl: {
    width: '4rem',
    height: '4rem',
    fontSize: '1.5rem',
    icon: {
      size: '1.5rem',
    },
    group: {
      offset: '-1rem',
    },
  },
  extend: {
    sm: {
      width: '1.5rem',
      height: '1.5rem',
      fontSize: '0.75rem',
      icon: {
        size: '0.75rem',
      },
      group: {
        offset: '-0.375rem',
      },
    },
    label: {
      fontWeight: '700',
      lineHeight: 'normal',
    },
  },
  css: ({ dt }) => `
    .p-avatar-sm {
      width: ${dt('avatar.sm.width')};
      height: ${dt('avatar.sm.height')};
      font-size: ${dt('avatar.sm.fontSize')};
    }

    .p-avatar-sm .p-avatar-icon {
      width: ${dt('avatar.sm.icon.size')};
      height: ${dt('avatar.sm.icon.size')};
    }

    .p-avatar-label {
      font-weight: ${dt('avatar.label.fontWeight')};
      line-height: ${dt('avatar.label.lineHeight')};
    }

    img {
      object-fit: cover;
    }

    .p-avatar-group slnk-common-user-avatar + slnk-common-user-avatar:has(.p-avatar-sm) {
      margin-inline-start: ${dt('avatar.sm.group.offset')};
    }

    .p-avatar-group slnk-common-user-avatar + slnk-common-user-avatar:has(.p-avatar) {
      margin-inline-start: ${dt('avatar.group.offset')};
    }

    .p-avatar-group slnk-common-user-avatar + slnk-common-user-avatar:has(.p-avatar-lg) {
      margin-inline-start: ${dt('avatar.lg.group.offset')};
    }

    .p-avatar-group slnk-common-user-avatar + slnk-common-user-avatar:has(.p-avatar-xl) {
      margin-inline-start: ${dt('avatar.xl.group.offset')};
    }
  `,
};
